import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import CollapsableCard from 'src/common/refactoredComponents/collapsableCard/CollapsableCard.jsx';
import {
    ProcedureDetailsTitle,
    ProcedureDetailsSubTitle,
    DetailsMainContainerBlock,
    MainContainerItems,
} from './ProcedureDetails.styled';
import edit from 'src/assets/images/Edit.svg';

import { useTranslation } from 'react-i18next';
import { VISIBLE } from 'src/constants/appConstants';


const ProcedureDetails = ({
    navigateToSpecifiedScreen,
    showEditButton,
    reviewScreen,
    title,
    fromReportPayment,
}) => {
    const { pediatricCheck,procedureTypeUsageVisibility,pediatricSurgery } = useSelector((state) => state.loginReducer);
const pediatricSurgeryVisibility =
        procedureTypeUsageVisibility === VISIBLE
            ? pediatricSurgery === VISIBLE
            : false;

    const reportUsageObject = useSelector(
        (state) => state.reportUsageRootReducer.reportUsageObject
    );
       const usageOrderSubmission = useSelector(
            (state) => state.reportUsageRootReducer.usageOrderSubmission
        );
        const restrictReviewScreen = useSelector(
            (state) => state.reportUsageRootReducer.restrictReviewScreen
    );
     const orderStatus = useSelector(
            (state) => state.reportUsageRootReducer.orderStatus
        );
    const isSectionPresent =
        reportUsageObject?.procedureDescription ||
        pediatricCheck !== '' ||
        pediatricCheck !== undefined;
    const isSubmitClicked = useSelector(
        (state) => state.reportUsageRootReducer.isSubmitClicked
    );
    const isUsagedSubmittedSuccessfully =
        (usageOrderSubmission && usageOrderSubmission.statusCode === '200') ||
        (Object.keys(orderStatus).length > 0 &&
            orderStatus.status &&
            orderStatus.status.includes('Usage Order Submitted Successfully'));
    const { t } = useTranslation();


    const [expandedCard, setExpandedCard] = useState({
        isProcedureDetails: false,
    });
    const toggleCard = (name, value) => {
        setExpandedCard({
            [name]: value,
        });
    };
    return (
        <>
            <CollapsableCard id="reportUsage-procedureDetails-procedureDetails-procedureDetails"
                title={t('orders.orderDetails.procedureData.procedureDetails')}
                onClick={() =>
                    toggleCard(
                        'isProcedureDetails',
                        !expandedCard?.isProcedureDetails
                    )
                }
                isExpanded={expandedCard?.isProcedureDetails}
                padding={'20px'}
                cursor={'pointer'}
                currentActivity={reviewScreen ? false : true}
                editButton={
                    isUsagedSubmittedSuccessfully ||
                    isSubmitClicked ||
                    !restrictReviewScreen
                        ? null
                        : showEditButton && edit
                }
                editPage={() => navigateToSpecifiedScreen('Procedure')}
                margin={fromReportPayment && '10px 0px 10px 0px'}
            >
                {expandedCard?.isProcedureDetails && isSectionPresent ? (
                    <DetailsMainContainerBlock>
                        {reportUsageObject?.procedureDescription ? (
                            <MainContainerItems setMarginBottom={true}>
                                <ProcedureDetailsTitle showAstrisk={false}>
                                    {t('common.procedureLabel')}
                                </ProcedureDetailsTitle>
                                <ProcedureDetailsSubTitle>
                                    {reportUsageObject?.procedureDescription}
                                </ProcedureDetailsSubTitle>
                            </MainContainerItems>
                        ) : null}
                        {pediatricCheck !== '' &&
                        pediatricCheck !== undefined &&pediatricSurgeryVisibility? (
                            <MainContainerItems setMarginBottom={true}>
                                <ProcedureDetailsTitle showAstrisk={false}>
                                    {t('common.pediatricProcedureUsage')}
                                </ProcedureDetailsTitle>
                                <ProcedureDetailsSubTitle>
                                    {pediatricCheck === true ? 'Yes' : 'No'}
                                </ProcedureDetailsSubTitle>
                            </MainContainerItems>
                        ) : null}
                    </DetailsMainContainerBlock>
                ) : null}
            </CollapsableCard>
        </>
    );
};

export default ProcedureDetails;
